export default __webpack_public_path__ + "static/media/downArrow.a7f84d2e.svg";